<app-order-documents [orderId]="data.orderId" [userId]="data.userId"
    [config]="orderDocumentsConfig"></app-order-documents>

<div mat-dialog-actions align="end">
    <button mat-flat-button color="primary" mat-dialog-close>Close</button>
</div>